import { useMemo } from 'react';

interface ObfuscatedEmailProps {
  user: string;
  domain?: string;
  className?: string;
}

function ObfuscatedEmail({
  user,
  domain = 'mail.myclinically.com',
  className,
}: ObfuscatedEmailProps) {
  // Email is assembled at runtime via JS - bots scanning HTML won't find it
  // The unicode escape \u0040 for @ adds another layer
  const email = useMemo(() => `${user}\u0040${domain}`, [user, domain]);

  return (
    <span className={className} aria-label={`${user} at ${domain}`}>
      {email}
    </span>
  );
}

export { ObfuscatedEmail };
